export default "__VITE_PUBLIC_ASSET__1d33e168__"